import { baseSiteEndPoint, buildHeaders } from "./common";
import Bugsnag from "@bugsnag/js";

export const apiCreateTicket = async (eventID, jsonData) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${eventID}/checkout/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });
    const data = await response.json();

    if (!response.ok) {
      const error = new Error(`Erro ${response.status}`);
      error.status = response.status;
      error.data = data;
      throw error;
    }

    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};

export const apiGetCheckout = async (eventID, checkoutID) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${eventID}/checkout/${checkoutID}/pay
`, {
      method: "GET",
      headers: buildHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Erro na resposta: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};

export const apiPayCheckout = async (eventID, checkoutID, jsonData) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${eventID}/checkout/${checkoutID}/pay/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Erro ${response.status}: ${errorData.message || 'Erro desconhecido'}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};

export const apiValidateCoupon = async (eventID, code) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${eventID}/checkout/validate-coupon/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ code })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Erro ${response.status}: ${errorData.message || 'Cupom inválido'}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};
